/**
 * Drawer Functionality
 */
function cdDrawers() {(function($) {
	const drawers   = '.drawers';
	const drawer    = `.drawer`;
	const label     = `${drawer}__label`;
	const content   = `${drawer}__content`;
	
	/**
	 * Open content when clicked, close all other open drawers
	 */
	function toggleDrawer(e) {
		e.preventDefault();
		
		const $drawer           = $(this).closest( '.drawer' );
		const $content          = $drawer.find( content );
		if( !$content.length ) return;
		
		const $container        = $drawer.closest( drawers );
		const $openDrawers      = $container.find( `${drawer}.open` );
		
		if( $drawer.hasClass('open') ) {
			$drawer.removeClass( 'open' );
			//$drawer.slideUp();
		} else {
			$openDrawers.each(function() {
				$(this).removeClass( 'open' );
				//$(this).slideUp();
			});
			$drawer.addClass( 'open' );
			//$drawer.slideDown();
		}
	}
	
	$(document).ready(function() {
		const $drawers = $( drawers );
		if( !$drawers.length ) return;
		
		$(label).on( 'click', toggleDrawer );
	});
})(jQuery);}
cdDrawers();